import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import ErrorIcon from '@mui/icons-material/Error'
import InfoIcon from '@mui/icons-material/Info'
import PendingIcon from '@mui/icons-material/Pending'
import { Tooltip } from '@mui/material'
import { FC } from 'react'
import { useTranslate } from 'react-admin'
import { CertificateStatus } from '../../types/apiRequests'
import EventNoteIcon from '@mui/icons-material/EventNote'

interface StatusIconProps {
  status?: CertificateStatus
  color?: boolean
}

const getStatusIcon = (color: boolean, status?: CertificateStatus) => {
  const iconColor = (defaultColor: 'info' | 'warning' | 'primary' | 'success' | 'error' | 'disabled') =>
    color ? defaultColor : 'disabled'

  switch (status) {
    case CertificateStatus.PENDING:
      return <PendingIcon color={iconColor('warning')} />
    case CertificateStatus.CSR_READY:
    case CertificateStatus.CSR_DOWNLOADED:
      return <InfoIcon color={iconColor('info')} />
    case CertificateStatus.CERT_UPLOADED:
      return <InfoIcon color={iconColor('primary')} />
    case CertificateStatus.INSTALL_SCHEDULED:
      return <EventNoteIcon color={iconColor('primary')} />
    case CertificateStatus.ACTIVE:
      return <CheckCircleIcon color={iconColor('success')} />
    case CertificateStatus.EXPIRED:
      return <ErrorIcon color={'error'} />
    case CertificateStatus.ERROR:
      return <ErrorIcon color={'error'} />
    default:
      return <PendingIcon color={iconColor('warning')} />
  }
}

const StatusIcon: FC<StatusIconProps> = ({ status, color = true }) => {
  const translate = useTranslate()
  const icon = getStatusIcon(color, status)

  return (
    <Tooltip title={translate(`resources.certificates.status.${status}`)}>
      {icon}
    </Tooltip>
  )
}

export default StatusIcon
